import { BaseTradeService } from '../../base-trade.service';
import { ProjectCommodityResponseDto } from '../dto/response/project-commodity-response.dto';
import { ProjectCommoditySaveRequestDto } from '../dto/request/project-commodity-save-request.dto';
import { ProjectCommodityUpdateRequestDto } from '../dto/request/project-commodity-update-request.dto';
import commodityService from '../../commodity/services/commodity.service';

class ProjectCommodityService extends BaseTradeService {
  public async fetchProjectCommoditiesByProjectId(
    id: string
  ): Promise<ProjectCommodityResponseDto[]> {
    const response = await this.get<ProjectCommodityResponseDto[]>(
      `/projectcommodity/getbyprojectid/${id}`
    );
    return response.data;
  }

  public async fetchProjectCommodityById(
    id: string
  ): Promise<ProjectCommodityResponseDto[]> {
    const response = await this.get<ProjectCommodityResponseDto[]>(
      `/projectcommodity/${id}`
    );
    return response.data;
  }

  public async fetchCommoditiesByProjectId(id: string) {
    const projectCommodities =
      await this.fetchProjectCommoditiesByProjectId(id);
    const commodityIds = projectCommodities.map((c) => c.commodityId);
    const commodities = await commodityService.fetchCommodities();
    return commodities.filter((c) => commodityIds.includes(c.id));
  }

  public async saveProjectCommodity(
    saveRequest: ProjectCommoditySaveRequestDto
  ): Promise<ProjectCommodityResponseDto> {
    const response = await this.post<ProjectCommodityResponseDto>(
      `/projectcommodity`,
      saveRequest
    );
    return response.data;
  }

  public async updateProjectCommodity(
    updateRequest: ProjectCommodityUpdateRequestDto
  ): Promise<ProjectCommodityResponseDto> {
    const response = await this.put<ProjectCommodityResponseDto>(
      `/projectcommodity`,
      updateRequest
    );
    return response.data;
  }

  public async deleteProjectCommodity(id: string): Promise<void> {
    await this.delete<void>(`/projectcommodity/${id}`);
  }
}

const projectCommodityService = new ProjectCommodityService();

export default projectCommodityService;
